export default __webpack_public_path__ + "static/media/ser7.9844a9d0.jpg";